import script from "./StaffEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./StaffEdit.vue?vue&type=script&setup=true&lang=js"

import "./StaffEdit.vue?vue&type=style&index=0&id=0ca143f3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ca143f3"]])

export default __exports__